import { createContext, useContext, useState } from 'react';
import { ReschedulerContextData, ReschedulerData, ReschedulerProviderProps } from './types';
import { initialState } from './constants';
import { Schedule } from '@root/globalTypes';

const ReschedulerContext = createContext<ReschedulerContextData | Record<string, never>>({});

export const ReschedulerProvider = ({ children }: ReschedulerProviderProps) => {
  const [state, setState] = useState<ReschedulerData>(initialState);

  const { relatedSchedules, savedSchedules } = state;

  const removeExistingSchedule = (arr: Schedule[], taskId?: string) =>
    arr.filter((el) => el.task?.id !== taskId);

  const isSavedSchedule = (value: Schedule) =>
    savedSchedules.some((el) => el.task?.id === value.task?.id);

  const appendSavedSchedule = (value: Schedule) => {
    if (!relatedSchedules.length) return;
    setState((prev) => ({
      ...prev,
      savedSchedules: [...removeExistingSchedule(prev.savedSchedules, value.task?.id), value],
    }));
  };

  const removeSavedSchedule = (value: Schedule) => {
    setState((prev) => ({
      ...prev,
      savedSchedules: removeExistingSchedule(prev.savedSchedules, value.task?.id),
    }));
  };

  return (
    <ReschedulerContext.Provider
      value={{ ...state, setState, isSavedSchedule, appendSavedSchedule, removeSavedSchedule }}>
      {children}
    </ReschedulerContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useRescheduler = () => useContext(ReschedulerContext);
